import I18n from 'i18n-js';
import { Alert } from '@helpers';

// Shown when the current version has no other version to diff against.
export const showNoVersionsToCompareAlert = () => {
  Alert({
    title: I18n.t('No versions available to compare'),
    actions: [{ text: I18n.t('OK'), style: 'primary' }],
  });
};
